import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import './Header.css';
import logo from '../../assets/logo.png';

function Header() {
  const location = useLocation();
  const isHomePage = location.pathname === '/';

  // Handle anchor navigation - if not on home page, navigate to home with hash
  const getAnchorLink = (hash) => {
    return isHomePage ? hash : `/${hash}`;
  };

  return (
    <header className="nav-header">
      <div className="logo">
        <Link to="/">
          <img src={logo} className="logo-image" alt="LeasEiZi Logo" />
        </Link>
      </div>
      <nav>
        <Link to={getAnchorLink('#howitworks')}>How It Works</Link>
        <Link to="/contact-us">Contact Us</Link>
        <Link to={getAnchorLink('#get-started')} className="get-started-btn">Get started</Link>
      </nav>
    </header>
  );
}

export default Header;
